import React, { useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import MainHeader from '../../components/MainHeader';
import MainView from '../../components/MainView';
import ProfileDetails from '../../components/ProfileDetails';
import ChangePassword from '../../components/ChangePassword';

import './index.css';
import ButtonPrimary from '../../components/ui/ButtonPrimary';

import './index.css';

const Profile = (props) => {
  const { signOut } = useContext(AuthContext);
  return (
    <div>
      <MainHeader title="Profile" />
      <MainView>
        <div className="profile">
          <div className="profile__left-bar">
            <ProfileDetails />
            <div className="profile__logout">
              <h3 className="profile__logout-title">don’t forget to log out</h3>
              <p className="profile__logout-paragraph">If you have completed your work, we recommend you log out. Be safe.</p>
              <ButtonPrimary name="Log out" className="profile__logout-btn btn btn--primary" onClick={signOut}/>
            </div>
          </div>
          <div className="profile__right-bar">
            <ChangePassword />
          </div>
        </div>
      </MainView>
      <p className="version">Version 0.1.5</p>
    </div>
  );
}

export default Profile;